import React from 'react';

const SocialProof = () => {
  // Stats and endorsements removed - ready for live data integration
  const stats = [];
  const endorsements = [];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Stats Grid - Hidden until live data available */}
        {stats?.length > 0 && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-20">
            {stats?.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl sm:text-4xl font-heading font-semibold text-primary mb-2">
                  {stat?.value}
                </div>
                <div className="text-sm text-muted-foreground">
                  {stat?.label}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Section Header - Hidden until endorsements available */}
        {endorsements?.length > 0 && (
          <>
            <div className="text-center mb-12">
              <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-foreground mb-4">
                Trusted by Relationship Professionals
              </h2>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Leading therapists and counselors recommend LoveNudge for couples seeking to deepen their connection.
              </p>
            </div>

            {/* Endorsements Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {endorsements?.map((endorsement, index) => (
                <div
                  key={index}
                  className="bg-card border border-border rounded-xl p-6 shadow-therapeutic-sm hover:shadow-therapeutic transition-all"
                >
                  <div className="flex items-center space-x-3 mb-4">
                    <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center text-primary font-heading font-semibold">
                      {endorsement?.avatar}
                    </div>
                    <div>
                      <div className="font-semibold text-foreground">{endorsement?.author}</div>
                      <div className="text-xs text-muted-foreground">{endorsement?.credentials}</div>
                    </div>
                  </div>
                  <p className="text-muted-foreground text-sm italic">
                    "{endorsement?.quote}"
                  </p>
                </div>
              ))}
            </div>
          </>
        )}

        {/* Certification Badges */}
        <div className="mt-16 flex flex-wrap items-center justify-center gap-8">
          <div className="flex items-center space-x-2 text-muted-foreground">
            <svg className="w-6 h-6 text-success" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            <span className="text-sm font-caption">HIPAA Compliant</span>
          </div>
          <div className="flex items-center space-x-2 text-muted-foreground">
            <svg className="w-6 h-6 text-success" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
            </svg>
            <span className="text-sm font-caption">End-to-End Encrypted</span>
          </div>
          <div className="flex items-center space-x-2 text-muted-foreground">
            <svg className="w-6 h-6 text-success" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            <span className="text-sm font-caption">SOC 2 Certified</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;